import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to display a audio popup
 */
export default class TimelineHotspot extends BaseHotspot {
  /**
   * Initialises an audio hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'timeline',
   *   options: {
   *     title: 'Title',
   *     scenes: [{
   *       id: 1,
   *       scene: scene uuid
   *       name: "Corridor West"
   *       date: "2/3/2021"
   *     }]
   *   }
   * }
   */
  constructor(player, config) {
    super(player, config);

    this.loadIcon(config.icon, "timeline.png");

    this._config = config;
  }
}
